// "Production" enabled environment

export const environment = {
    production: true,
    hmr: false,
    appConfig: 'appconfig.staging.json',
    datePickerThemeClass: 'theme-dark-blue',
    defaultTenantId: 2
};
